/** Largest range that expands, so a typo like "1-1000" can't flood the form. */
export const RANGE_LIMIT = 100;

const RANGE = /^(.*?)(\d+)\s*[-–]\s*(\d+)(.*)$/;

/**
 * Names typed or pasted as one list: split on new lines and commas, trimmed,
 * blanks and repeats dropped, original order kept. With `ranges`, a numeric
 * range expands — "Class 1-3" gives Class 1, Class 2, Class 3.
 */
export const parseNameList = (raw: string, { ranges = false } = {}): string[] => {
  const out: string[] = [];
  const seen = new Set<string>();
  const add = (name: string) => {
    const key = name.toLowerCase();
    if (!name || seen.has(key)) return;
    seen.add(key);
    out.push(name);
  };
  raw.split(/[\n,]/).map(s => s.trim().replace(/\s+/g, ' ')).forEach(part => {
    const m = ranges ? part.match(RANGE) : null;
    const from = m ? Number(m[2]) : 0;
    const to = m ? Number(m[3]) : 0;
    if (m && from <= to && to - from < RANGE_LIMIT) {
      for (let n = from; n <= to; n += 1) add(`${m[1]}${n}${m[4]}`.trim());
    } else {
      add(part);
    }
  });
  return out;
};
